// @ts-check
import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  actionsButtonLabel: {
    id: 'course-authoring.taxonomy-menu.action.button.label',
    defaultMessage: 'Acciones',
  },
  actionsButtonAlt: {
    id: 'course-authoring.taxonomy-menu.action.button.alt',
    defaultMessage: '{name} acciones',
  },
  importMenu: {
    id: 'course-authoring.taxonomy-menu.import.label',
    defaultMessage: 'Re-importar',
  },
  manageOrgsMenu: {
    id: 'course-authoring.taxonomy-menu.assign-orgs.label',
    defaultMessage: 'Administrar Organizaciones',
  },
  exportMenu: {
    id: 'course-authoring.taxonomy-menu.export.label',
    defaultMessage: 'Exportar',
  },
  deleteMenu: {
    id: 'course-authoring.taxonomy-menu.delete.label',
    defaultMessage: 'Eliminar',
  },
  taxonomyDeleteToast: {
    id: 'course-authoring.taxonomy-list.toast.delete',
    defaultMessage: '"{name}" eliminado',
  },
});

export default messages;
